<template>
  <div
    class="dropdown"
    :class="{ small, open: isOpened }"
  >
    <a
      href="#"
      :title="toggleText"
      class="dropdown-toggle"
      :class="{ [toggleClass]: toggleClass, disabled }"
      @click.prevent
    >
      <Icon
        v-if="toggleIcon"
        :name="toggleIcon"
      />
      {{ optionLabel }}
      <b class="caret" />
    </a>
    <ul
      class="dropdown-menu"
      :class="scrollable ? `dropdown-menu-scrollable` : ``"
    >
      <li
        v-for="(item) in options"
        :key="`${item.name}`"
      >
        <a
          :title="item.name"
          href="#"
          :class="{ disabled: item.disabled }"
          @click.prevent="selectOption(item)"
        >
          <span
            v-if="item.iconPath"
            class="icon"
          >
            <img
              :src="item.iconPath"
              :alt="item.iconPath"
            >
          </span>
          {{ item.name }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref, toRefs, computed } from 'vue'
import Icon from '@/components/CommonUI/Icon.vue'

interface Props {
  options: DropdownOption[],
  selectedOptionId: number,
  small?: boolean,
  scrollable?: boolean,
  toggleClass?: string,
  toggleIcon?: string | null,
  toggleText?: string,
  disabled?: boolean,
}

const props = withDefaults(defineProps<Props>(), {
  small: false,
  scrollable: false,
  toggleClass: '',
  toggleIcon: null,
  toggleText: '',
  disabled: false,
})

const {
  options,
  toggleText,
} = toRefs(props)

const isOpened = ref(false)
const selectedOptionId = ref(props.selectedOptionId)
const optionLabel = computed(() => {
  const option = options.value.find(({ id }) => id === selectedOptionId.value)

  return option?.name || toggleText.value
})

const emit = defineEmits<{(e: 'selected', id: number): void}>()

function selectOption(option: DropdownOption) {
  if (option.disabled) return

  selectedOptionId.value = option.id
  emit('selected', option.id)
}
</script>
